import { render, staticRenderFns } from "./CountDownLogoff.vue?vue&type=template&id=ca4c1d36"
import script from "./CountDownLogoff.vue?vue&type=script&lang=js"
export * from "./CountDownLogoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports